export enum ObjectType {
    FILE = 'FILE',
    FOLDER = 'FOLDER'
}